export default __webpack_public_path__ + "static/media/ambulance_icon.9b1df3a4.svg";